import { GlButton, GlFormCheckbox, GlFormInput, GlTooltipDirective } from '@gitlab/ui';
import { getDraft, updateDraft } from '~/lib/utils/autosave';
import { s__ } from '~/locale';
import { stripDuoAnswerMarker } from '../../utils/duo_question';
export default {
    name: 'DuoCustomAnswerInput',
    components: {
        GlButton,
        GlFormCheckbox,
        GlFormInput
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        draftKey: {
            type: String,
            required: true
        },
        inputId: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        submitting: {
            type: Boolean,
            required: false,
            default: false
        },
        multiple: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'submit',
        'change'
    ],
    data () {
        const customAnswer = getDraft(this.draftKey) ?? '';
        // A draft restored from a previous visit counts already, so it starts ticked.
        return {
            customAnswer,
            isSelected: stripDuoAnswerMarker(customAnswer).length > 0
        };
    },
    computed: {
        label () {
            return stripDuoAnswerMarker(this.customAnswer);
        },
        canSubmit () {
            return this.label.length > 0 && !this.disabled;
        },
        tooltip () {
            return this.canSubmit ? '' : s__('WorkItemDuoQuestion|An answer is required to submit');
        },
        selectedAnswer () {
            return this.isSelected ? this.label : '';
        },
        isChecked () {
            return this.multiple && this.isSelected;
        }
    },
    watch: {
        customAnswer (value, previous) {
            updateDraft(this.draftKey, value);
            // The checkmark follows the text appearing and disappearing, not every edit in between:
            // an answer checked off by hand stays out while it is corrected, and clearing the
            // text takes it away rather than leaving a checkbox with nothing in it.
            if (!this.label.length) {
                this.isSelected = false;
            } else if (!stripDuoAnswerMarker(previous).length) {
                this.isSelected = true;
            }
        },
        selectedAnswer: {
            immediate: true,
            handler (value) {
                this.$emit('change', value);
            }
        }
    },
    methods: {
        // Enter reaches this even when the button is disabled, so the guard is not
        // redundant with the button's `disabled`.
        submit () {
            if (this.canSubmit) this.$emit('submit', this.label);
        },
        onEnter () {
            if (!this.multiple) this.submit();
        }
    }
};
